import * as _ from 'lodash';
import {cigDecode, serverLog, verifyCookieContainTenantId} from '../common/utils';
import {CIG_SSO} from '../common/constants';

export function getRedirectTenantInfo(props) {
    let retProps = {
        hostName: '',
        status: '',
        tenantId: '',
        tenantInfo: {},
        errorStatus: false,
        tenantRegion: '',
        uiMode: '',
    };
    if (!_.isNil(props.newTenantInfo) && !_.isEmpty(props.newTenantInfo)) {
        retProps.hostName = _.get(props.newTenantInfo, 'hostname', '');
        retProps.status = _.get(props.newTenantInfo, 'status', '');
        retProps.tenantId = _.get(props.newTenantInfo, 'tenantId', '');
        retProps.tenantInfo = _.get(props, 'newTenantInfo', {});
        retProps.location = _.get(props.newTenantInfo, 'location', {});
        retProps.uiMode = _.get(props.newTenantInfo, 'uiMode', '');

    }
    else if (!_.isUndefined(props.tenants) && props.tenants.length > 0) {
        retProps.hostName = _.get(props.tenants[0], 'hostname', '');
        retProps.status = _.get(props.tenants[0], 'status', '');
        retProps.tenantId = _.get(props.tenants[0], 'tenantId', '');
        retProps.tenantInfo = _.get(props, 'tenants[0]', {});
        retProps.location = _.get(props.tenants[0], 'location', {});
        retProps.uiMode = _.get(props.tenants[0], 'uiMode', '');
    }

    if (_.startsWith(retProps.status, 'FAILED') || _.startsWith(retProps.status, 'DELETED')) {
        const logPrefix = 'Utils: getRedirectTenantInfo - Create tenant status ' + retProps.status + ' - tenant info: ';
        const error = {
            category: 'ERROR',
            logMessage: logPrefix + (_.isNil(retProps.tenantInfo) ? '' : JSON.stringify(retProps.tenantInfo)),
        };
        serverLog(props.auth, error);
        retProps.errorStatus = true;
    }
    return retProps;
}

export function getSite(site, auth) {
    if (_.isEmpty(site)) {
        const searchParams = sessionStorage.getItem(CIG_SSO.sessionKey) || verifyCookieContainTenantId();
        if (searchParams === false)
            return;

        try {
            const qStr = JSON.parse(cigDecode(searchParams));
            if (Object.prototype.hasOwnProperty.call(qStr, CIG_SSO.ociSite)) {
                return qStr[CIG_SSO.ociSite];
            }
        }
        catch (e) {
            const logMessage = 'Utils: getSite - Parse JSON error: ' + e +  ' tenant: ' + site + ' searchParams: ' + searchParams;
            const error = {
                category: 'ERROR',
                logMessage: logMessage,
            };
            serverLog(auth, error);
        }
    }
    return site;
}
